import React from 'react';

export const EyeGray400: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M9.33268 7.99984C9.33268 8.35346 9.19221 8.6926 8.94216 8.94265C8.69211 9.19269 8.35297 9.33317 7.99935 9.33317C7.64573 9.33317 7.30659 9.19269 7.05654 8.94265C6.80649 8.6926 6.66602 8.35346 6.66602 7.99984C6.66602 7.64622 6.80649 7.30708 7.05654 7.05703C7.30659 6.80698 7.64573 6.6665 7.99935 6.6665C8.35297 6.6665 8.69211 6.80698 8.94216 7.05703C9.19221 7.30708 9.33268 7.64622 9.33268 7.99984Z"
        fill="#888888"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.99995 2C4.27195 2 1.13995 4.54933 0.251953 8C1.13995 11.4507 4.27195 14 7.99995 14C11.728 14 14.86 11.4507 15.748 8C14.86 4.54933 11.728 2 7.99995 2ZM10.6666 8C10.6666 8.70724 10.3857 9.38552 9.88557 9.88562C9.38547 10.3857 8.7072 10.6667 7.99995 10.6667C7.29271 10.6667 6.61443 10.3857 6.11433 9.88562C5.61424 9.38552 5.33329 8.70724 5.33329 8C5.33329 7.29276 5.61424 6.61448 6.11433 6.11438C6.61443 5.61428 7.29271 5.33333 7.99995 5.33333C8.7072 5.33333 9.38547 5.61428 9.88557 6.11438C10.3857 6.61448 10.6666 7.29276 10.6666 8Z"
        fill="#888888"
      />
    </svg>
  );
};
